// extracted by mini-css-extract-plugin
export var red = "main-module--red--39145";
export var small = "main-module--small--1b43f";
export var subtitle = "main-module--subtitle--a247b";
export var title = "main-module--title--37e3c";
export var violet = "main-module--violet--8067e";